/** Lê um CSV simples: separador ; ou , (o que aparecer mais na primeira linha), aspas duplas opcionais. */
export function lerCsv(texto: string): string[][] {
  const limpo = texto.replace(/^﻿/, '')
  const primeira = limpo.split(/\r?\n/)[0] || ''
  const sep = (primeira.match(/;/g) || []).length >= (primeira.match(/,/g) || []).length ? ';' : ','
  const linhas: string[][] = []
  let campo = '', linha: string[] = [], aspas = false
  for (let i = 0; i < limpo.length; i++) {
    const c = limpo[i]
    if (aspas) {
      if (c === '"' && limpo[i + 1] === '"') { campo += '"'; i++ } else if (c === '"') aspas = false
      else campo += c
    } else if (c === '"') aspas = true
    else if (c === sep) { linha.push(campo); campo = '' }
    else if (c === '\n' || c === '\r') {
      if (c === '\r' && limpo[i + 1] === '\n') i++
      linha.push(campo); linhas.push(linha); linha = []; campo = ''
    } else campo += c
  }
  if (campo || linha.length) { linha.push(campo); linhas.push(linha) }
  return linhas.map(l => l.map(x => x.trim())).filter(l => l.some(x => x))
}

export interface LinhaItem { linha: number; email: string; atributo: string; valor: string; dashboard?: string; ambiente?: string }

const COLUNAS = ['email', 'atributo', 'valor', 'dashboard', 'ambiente'] as const
const semAcento = (t: string) => t.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z]/g, '')

/**
 * As linhas da planilha de itens de regra: e-mail; atributo; valor; dashboard; ambiente.
 * Com cabeçalho, as colunas são achadas pelo nome (em qualquer ordem); sem, valem nessa ordem.
 */
export function linhasDeItens(texto: string): LinhaItem[] {
  const linhas = lerCsv(texto)
  const cab = (linhas[0] || []).map(semAcento)
  const temCabecalho = cab.some(c => c === 'email')
  const pos = Object.fromEntries(COLUNAS.map((c, i) => [c, temCabecalho ? cab.indexOf(c) : i])) as Record<typeof COLUNAS[number], number>
  const ler = (l: string[], c: typeof COLUNAS[number]) => (pos[c] >= 0 ? l[pos[c]] || '' : '')
  return linhas.slice(temCabecalho ? 1 : 0).map((l, i) => ({
    linha: i + (temCabecalho ? 2 : 1), email: ler(l, 'email'), atributo: ler(l, 'atributo'), valor: ler(l, 'valor'),
    dashboard: ler(l, 'dashboard') || undefined, ambiente: ler(l, 'ambiente') || undefined
  }))
}

/** Baixa um texto como arquivo (o modelo da planilha). */
export function baixarArquivo(nome: string, conteudo: string, tipo = 'text/csv;charset=utf-8') {
  const url = URL.createObjectURL(new Blob(['﻿' + conteudo], { type: tipo }))
  const a = document.createElement('a')
  a.href = url
  a.download = nome
  a.click()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
